import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/forgotpassword/${token}`,
        {
          method: "POST",
          body: JSON.stringify({ password }),
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || t("error_occurred"));
      }
      setMessage(data.message);
      setIsSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <Container>
        <Row className="justify-content-center">
          <Col md={4} className="shadow p-4">
            <h2 className="text-center mb-4">{t("reset_password_title")}</h2>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>{t("new_password_label")}</Form.Label>
                <Form.Control
                  type="password"
                  placeholder={t("new_password_placeholder")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>
              <Button
                type="submit"
                variant="primary"
                className="w-100"
                disabled={isLoading}
                style={{ height: "40px" }}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  t("reset_button")
                )}
              </Button>
            </Form>

            {message && (
              <Alert variant="success" className="mt-3">
                {message}
              </Alert>
            )}
            {error && (
              <Alert variant="danger" className="mt-3">
                {error}
              </Alert>
            )}

            {isSuccess && (
              <Button
                variant="success"
                className="w-100 mt-3"
                onClick={() => navigate("/login")}
              >
                {t("login_button")}
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ResetPassword;
